import { shouldUseClubRedesignForClub } from 'src/content/club-look-ups-by-id';
import type { ClubCmsRecord } from 'src/content/cms-provider/club-cms-provider';

import type { ClubPhoneNumber, ContactDetails } from '../common/contact-details';

export const HEAD_OFFICE_PHONE_NUMBER = '+44 (0)1707 283500';

export const getClubPhoneNumber = (
  phoneNumbers: readonly ClubPhoneNumber[] | undefined,
  numberType: string
): string => {
  const phoneNumber = phoneNumbers?.find(
    (clubPhoneNumber: ClubPhoneNumber) => clubPhoneNumber.description.trim() === numberType
  );
  return phoneNumber ? phoneNumber.number : HEAD_OFFICE_PHONE_NUMBER;
};

const isPostCode = (part: string): boolean => /\w{1,2}\d{1,2}\s\d\w{2}/.test(part);

export const getAddressParts = (
  contactDetails: ContactDetails
): { streetAddress: string | undefined; postCode: string } => {
  let streetAddress = contactDetails?.address1?.trim();
  const splitAddress = contactDetails?.address2?.split(', ');
  let postCode = '';

  if (splitAddress?.length === 1) {
    postCode = isPostCode(splitAddress[0]) ? splitAddress[0] : '';
  } else if (splitAddress && splitAddress?.length > 1) {
    postCode = splitAddress[splitAddress.length - 1];
    splitAddress.pop();
    const addressLine2 = splitAddress.join(', ');
    const streetAddressEndsWithComma =
      streetAddress && streetAddress.lastIndexOf(',') + 1 === streetAddress?.length;
    streetAddress = streetAddressEndsWithComma
      ? streetAddress?.concat(' ').concat(addressLine2)
      : streetAddress?.concat(', ').concat(addressLine2);
  }

  return { streetAddress, postCode };
};

export const CLUB_PHONE_NON_MEMBERS_DESCRIPTION = 'Non-members:';

export const getContactDetails = (
  cmsContent: Partial<ClubCmsRecord>,
  siteId: string
): ContactDetails => {
  const isClubUsingRedesign = shouldUseClubRedesignForClub(siteId);
  const sharedContentToUse = isClubUsingRedesign
    ? cmsContent?.newSharedContent
    : cmsContent?.sharedContent;

  const newNonMembersPhoneNumber =
    cmsContent?.newSharedContent?.phoneNumbers?.nonMembersPhoneNumber?.trim();
  const redesignPhoneNumbers = newNonMembersPhoneNumber
    ? [
        {
          description: CLUB_PHONE_NON_MEMBERS_DESCRIPTION,
          number: newNonMembersPhoneNumber,
        },
      ]
    : [];

  return {
    clubName: (cmsContent?.clubDetails as { clubName?: string } | undefined)?.clubName,
    hyphenatedClubName: (cmsContent?.clubDetails as { hyphenatedClubName?: string } | undefined)
      ?.hyphenatedClubName,
    address1: sharedContentToUse?.clubLocation?.text1,
    address2: sharedContentToUse?.clubLocation?.text2,
    clubPhoneNumbers: isClubUsingRedesign
      ? redesignPhoneNumbers
      : cmsContent?.sharedLandingContent?.clubPhoneNumbers,
    clubEmail: sharedContentToUse?.clubEmail,
  };
};
